<div class="input-group">
    <input
        #dateTimeInput
        class="form-control datetime-input"
        type="datetime-local"
        [formControl]="dateTimeInputControl"
        paceCoreValidationMessage
        [validation]="dateTimeInputControl"
        [attr.aria-label]="ariaLabel"
    />
    <span class="input-group-text" (click)="onClick(dateTimeInput)"><fa-icon [icon]="faCalendar"></fa-icon></span>
</div>
